import { useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import UpdateShipToCustomerMutation from '@/graphql/contracts/updateShipToCustomer.mutation.gql';
import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { UpdateShipToCustomer, UpdateShipToCustomerVariables } from
  '@/graphql/contracts/_generated_/updateShipToCustomer.mutation';
import { UpdateShipToCustomerInputType } from '@/graphql/contracts/_generated_/contracts';
import { ALL_ITEMS } from '@/config/common.config';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';

export default function useUpdateShipToCustomer() {
  const { contractId }: { contractId: string } = useParams();

  const [_updateShipToCustomer, { loading, error, called }] =
    useMutation<UpdateShipToCustomer, UpdateShipToCustomerVariables>(
      UpdateShipToCustomerMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetContractDetailsQuery,
            variables: {
              contractId,
            }
          },
          {
            query: GetBCContractLinesQuery,
            variables: {
              filter: {
                contractId: { eq: contractId }
              },
              first: ALL_ITEMS
            }
          },
          {
            query: GetPaginatedFilteredVariableContractLinesQuery,
            variables: {
              filter: { headerPrimaryKey: { eq: contractId } },
              first: ALL_ITEMS,
            }
          }
        ],
      }
    );
  const updateShipToCustomer = async (input: UpdateShipToCustomerInputType) => {
    await _updateShipToCustomer({
      variables: { input }
    });
  };

  return {
    updateShipToCustomer,
    isLoadingUpdateShipToCustomer: loading,
    errorUpdateShipToCustomer: error,
    isUpdateShipToCustomerWasCalled: called
  } as const;
}
